import styled from 'styled-components';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

const Branding = styled('p')`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 17.5px;
  line-height: 1.71;
  color: #747474;
`;

export default Branding;
